import CheckIcon from '@mui/icons-material/Check';
import { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { AVAILABLE_LANGUAGES, LOCAL_STORAGE_LANGUAGE_KEY } from 'config/constants';
import '../../style.scss';

export const LanguageSelector = () => {
  const { t, i18n } = useTranslation();
  const [selected, setSelected] = useState<string>(i18n.language);

  const handleLanguageChange = useCallback((clickedItem: string) => {
    i18n.changeLanguage(clickedItem);
    setSelected(clickedItem);
    localStorage.setItem(LOCAL_STORAGE_LANGUAGE_KEY, clickedItem);
  }, []);

  return (
    <ul>
      {Object.values(AVAILABLE_LANGUAGES).map((language) => (
        <li
          key={language}
          data-testid="language"
          className="is-flex is-align-items-center language-selector"
          onClick={() => handleLanguageChange(language)}
        >
          <div className="is-flex is-align-items-center" style={{ width: '100%' }}>
            <div className="is-flex is-align-items-center" style={{ width: '15%' }}>
              {language === selected && (
                <CheckIcon data-testid="selected-icon" fontSize="small" color="primary" />
              )}
            </div>
            <div data-testid="language-name" style={{ width: '85%' }}>
              {t(`components:header.user_menu.language.${language}`)}
            </div>
          </div>
        </li>
      ))}
    </ul>
  );
};
